import React, { useState } from 'react'
import { Box, Slide, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Layout, SpeedDialCustom } from '../../components'
import {
  BannersSection,
  RulesSection,
  MapsSection,
  NewsSection,
  WinnersSection,
  LegendSection,
  ReportCupSection,
} from './section'
import { useReduxSelector } from '../../hooks'

export const MainPage: React.FC = (): JSX.Element => {
  const classes = useStyles()

  const { data: constants } = useReduxSelector((state) => state.constants)
  const { auth } = useReduxSelector((state) => state.auth)

  const [showFab, setShowFab] = useState<boolean>(false)

  function handleScroll() {
    if (window.pageYOffset > 150) {
      setShowFab(true)
    } else {
      setShowFab(false)
    }
  }

  const fabRef = () => {
    window.addEventListener('scroll', handleScroll)
  }

  return (
    <>
      <Layout>
        <Box ref={fabRef} className={classes.page}>
          {/* <BannersSection /> */}
          <LegendSection />
          <Box id="rules">
            {/* <RulesSection /> */}
            <ReportCupSection />
          </Box>
          {auth && (
            <>
              <Box id="tourtable">
                <WinnersSection />
              </Box>
              <Box id="news">
                <NewsSection />
              </Box>
              {/* <Box id="maps"> */}
              {/*  <MapsSection /> */}
              {/* </Box> */}
            </>
          )}
        </Box>
      </Layout>
      {constants?.IS_PROJECT_START_ACTION && showFab && <SpeedDialCustom />}
    </>
  )
}

const useStyles = makeStyles(({ spacing, font, breakpoints: { down }, palette }: Theme) => ({
  page: {},
}))
